import client from '../client';
import endpoints from '../endpoints';

/**
 * 목적지/공통 데이터 — 서비스 + 관리자 API
 * API_DOCS: 8. 공통 데이터 / 7. 가용성 / 21. 관리자 - 목적지
 */

/* ── 서비스 (유저용) — 공통 데이터 ── */

/** GET /api/airports — returns { key, items } → normalize to items array */
export const getAirports = async (params = {}) => {
  const res = await client.get(endpoints.common.airports, { params });
  return res.data?.items || res.data;
};

/** GET /api/golf-courses */
export const getGolfCourses = async (params = {}) => {
  const res = await client.get(endpoints.common.golfCourses, { params });
  return res.data;
};

/** GET /api/ski-resorts */
export const getSkiResorts = async (params = {}) => {
  const res = await client.get(endpoints.common.skiResorts, { params });
  return res.data;
};

/** GET /api/hospitals */
export const getHospitals = async (params = {}) => {
  const res = await client.get(endpoints.common.hospitals, { params });
  return res.data;
};

/** GET /api/buffer-settings?service_type= */
export const getBufferSettings = async (serviceType) => {
  const res = await client.get(endpoints.common.bufferSettings, { params: { service_type: serviceType } });
  return res.data;
};

/** GET /api/vehicles */
export const getVehicles = async () => {
  const res = await client.get(endpoints.common.vehicles);
  return res.data;
};

/* ── 서비스 — 가용성 ── */

/** GET /api/availability/check */
export const checkAvailability = async (params = {}) => {
  const res = await client.get(endpoints.availability.check, { params });
  return res.data;
};

/** GET /api/availability/calendar */
export const getAvailabilityCalendar = async (params = {}) => {
  const res = await client.get(endpoints.availability.calendar, { params });
  return res.data;
};

/* ── 관리자 — 골프장 CRUD ── */

export const getAdminGolfCourses = async (params = {}) => {
  const res = await client.get(endpoints.admin.golfCourses.list, { params });
  return res.data;
};

export const createAdminGolfCourse = async (data) => {
  const res = await client.post(endpoints.admin.golfCourses.list, data);
  return res.data;
};

export const updateAdminGolfCourse = async (id, data) => {
  const res = await client.put(endpoints.admin.golfCourses.detail(id), data);
  return res.data;
};

export const deleteAdminGolfCourse = async (id) => {
  const res = await client.delete(endpoints.admin.golfCourses.detail(id));
  return res.data;
};

/* ── 관리자 — 스키장 CRUD (BugHerd #99 복원) ── */

export const getAdminSkiResorts = async (params = {}) => {
  const res = await client.get(endpoints.admin.skiResorts.list, { params });
  return res.data;
};

export const createAdminSkiResort = async (data) => {
  const res = await client.post(endpoints.admin.skiResorts.list, data);
  return res.data;
};

export const updateAdminSkiResort = async (id, data) => {
  const res = await client.put(endpoints.admin.skiResorts.detail(id), data);
  return res.data;
};

export const deleteAdminSkiResort = async (id) => {
  const res = await client.delete(endpoints.admin.skiResorts.detail(id));
  return res.data;
};

/* ── 관리자 — 병원 CRUD ── */

export const getAdminHospitals = async (params = {}) => {
  const res = await client.get(endpoints.admin.hospitals.list, { params });
  return res.data;
};

export const createAdminHospital = async (data) => {
  const res = await client.post(endpoints.admin.hospitals.list, data);
  return res.data;
};

export const updateAdminHospital = async (id, data) => {
  const res = await client.put(endpoints.admin.hospitals.detail(id), data);
  return res.data;
};

export const deleteAdminHospital = async (id) => {
  const res = await client.delete(endpoints.admin.hospitals.detail(id));
  return res.data;
};

/* ── 관리자 — 출발 지역 CRUD ── */

export const getAdminDepartureRegions = async () => {
  const res = await client.get(endpoints.admin.departureRegions.list);
  return res.data;
};

export const createAdminDepartureRegion = async (data) => {
  const res = await client.post(endpoints.admin.departureRegions.list, data);
  return res.data;
};

export const updateAdminDepartureRegion = async (id, data) => {
  const res = await client.put(endpoints.admin.departureRegions.detail(id), data);
  return res.data;
};

export const deleteAdminDepartureRegion = async (id) => {
  const res = await client.delete(endpoints.admin.departureRegions.detail(id));
  return res.data;
};

/* ── 관리자 — 병원 지역 CRUD ── */

export const getAdminHospitalRegions = async () => {
  const res = await client.get(endpoints.admin.hospitalRegions.list);
  return res.data;
};

export const createAdminHospitalRegion = async (data) => {
  const res = await client.post(endpoints.admin.hospitalRegions.list, data);
  return res.data;
};

export const updateAdminHospitalRegion = async (id, data) => {
  const res = await client.put(endpoints.admin.hospitalRegions.detail(id), data);
  return res.data;
};

export const deleteAdminHospitalRegion = async (id) => {
  const res = await client.delete(endpoints.admin.hospitalRegions.detail(id));
  return res.data;
};
